import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MediaMatcher } from '@angular/cdk/layout';

export interface confirmDialogData {
  title?: string;
  message?: string;
  subtext?: string;
  saveText?: string;
  acceptText?: string;
  cancelText?: string;
  hideCancelButton?: boolean;
  subActions?: any[];
}

@Component({
  selector: 'lib-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  public confirmMessage: string = "";
  subtext: any = '';
  mobileQuery: MediaQueryList;
  acceptText = 'Aceptar';
  cancelText = 'Cancelar';
  title = 'Confirmar operación';
  hideCancelButton = false;
  activeSubActions: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: confirmDialogData,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,) {
    if (data.message) {
      this.confirmMessage = data.message;
    }
    if (data.saveText) {
      this.acceptText = data.saveText
    }
    if (data.cancelText) {
      this.cancelText = data.cancelText
    }
    if (data.title) {
      this.title = data.title
    }
    if (data.hideCancelButton) {
      this.hideCancelButton = true;
    }
    this.subtext = data.subtext;
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
    if (data.subActions) {
      this.activeSubActions = true
    }
  }

  ngOnInit() {
  }

  private mobileQueryListener: () => void;

}
